<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <!-- Summary -->
    <div class="row clearfix">
      <div class="col-12">
        <div class="card top_report card-top-line">
          <div class="row clearfix">
            <div class="col-lg-3 col-md-6 col-sm-6">
              <div class="body d-flex flex-column">
                <div class="d-flex justify-content-between">
                  <i class="fa fa-2x fa fa-user-plus"></i>
                  <div class="d-flex flex-column justify-content-center text-right">
                    <h6>New Remitters(today)</h6>
                    <span class="font-weight-normal">
                      {{ customerInfo.today }}
                    </span>
                  </div>
                </div>
                <div class="progress progress-xs mb-0 mt-3">
                  <div
                    role="progressbar"
                    aria-valuenow="20"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    class="progress-bar bg-success"
                    v-bind:style="{
                      width: (customerInfo.today * 100) / customerInfo.month + '%',
                    }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
              <div class="body d-flex flex-column">
                <div class="d-flex justify-content-between">
                  <i class="fa fa-2x fa fa-calendar"></i>
                  <div class="d-flex flex-column justify-content-center text-right">
                    <h6>New This Month</h6>
                    <span class="font-weight-normal">
                      {{ customerInfo.month }}
                    </span>
                  </div>
                </div>
                <div class="progress progress-xs mb-0 mt-3">
                  <div
                    role="progressbar"
                    aria-valuenow="20"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    class="progress-bar bg-success"
                    v-bind:style="{
                      width: (customerInfo.month * 100) / customerInfo.valid + '%',
                    }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
              <div class="body d-flex flex-column">
                <div class="d-flex justify-content-between">
                  <i class="fa fa-2x fa fa-users"></i>
                  <div class="d-flex flex-column justify-content-center text-right">
                    <h6>Valid Remitters</h6>
                    <span class="font-weight-normal">
                      {{ customerInfo.valid }}
                    </span>
                  </div>
                </div>
                <div class="progress progress-xs mb-0 mt-3">
                  <div
                    role="progressbar"
                    aria-valuenow="20"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    class="progress-bar bg-success"
                    v-bind:style="{
                      width: (customerInfo.valid * 100) / customerInfo.total + '%',
                    }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
              <div class="body d-flex flex-column">
                <div class="d-flex justify-content-between">
                  <i class="fa fa-2x fa fa-users"></i>
                  <div class="d-flex flex-column justify-content-center text-right">
                    <h6>Total Remitters</h6>
                    <span class="font-weight-normal">
                      {{ customerInfo.total }}
                    </span>
                  </div>
                </div>
                <div class="progress progress-xs mb-0 mt-3">
                  <div
                    role="progressbar"
                    aria-valuenow="20"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    class="progress-bar bg-success"
                    v-bind:style="{
                      width:
                        (customerInfo.total * 100) /
                          (Math.ceil(customerInfo.total / 1000) * 1000) +
                        '%',
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Remitter List</h2>
          </div>
          <!-- Members Listing-->
          <div class="body pt-0">
            <!-- Linked Risk info banner -->
            <div class="alert linked-risk-banner mt-3 mb-0" role="alert">
              <i class="fa fa-info-circle mr-2" aria-hidden="true"></i>
              The <strong>Linked Risk</strong> column flags remitters whose
              receivers share a mobile, MOMO, or bank account with other
              remitters. Click <strong>View receivers</strong> to see them, or
              <strong>Why?</strong> for the risk breakdown. The badge is
              informational — any action still needs analyst review.
            </div>
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-3 fresh-customer-filter"
            >
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Keywords"
                    aria-label="Search"
                    v-model="search_keywords"
                    v-on:keyup.enter="searchCustomer"
                    aria-describedby="search-transactions"
                  />
                  <div class="input-group-append" @click="searchCustomer()">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div class="form-group form-select single-multiselect m-0 column-1">
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'firstname' ||
                          item.field.id == 'lastname' ||
                          item.field.id == 'middlename' ||
                          item.field.id == 'address' ||
                          item.field.id == 'ipaddress' ||
                          item.field.id == 'city' ||
                          item.field.id == 'state')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'remitstatus'"
                    >
                      <span class="float-label w-100">
                        <label>Select Remiter Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="remiterStatus"
                          label="value"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>

                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'idverificationstatus'"
                    >
                      <span class="float-label w-100">
                        <label>Select ID Verification Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="idverificationStatus"
                          label="name"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>

                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'remitgroup'"
                    >
                      <span class="float-label w-100">
                        <label>Select Remiter Group</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="remiterOption"
                          label="groupname"
                          track-by="groupid"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'registered'"
                    >
                      <span class="float-label w-100">
                        <label>Select Registration Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="registrationStatus"
                          label="name"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'accountstatus'"
                    >
                      <span class="float-label w-100">
                        <label>Select Account Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="accountStatusOptions"
                          label="name"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'country'"
                    >
                      <span class="float-label w-100">
                        <label>Select Country</label>
                        <v-select
                          :options="countryList"
                          multiple
                          v-model="item.country"
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div class="column-2" v-if="item.field && item.field.id == 'date'">
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button class="btn btn-primary w-auto" @click="applyTestfilter">
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearALLfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i class="fa fa-filter text-primary mr-1 mb-2" aria-hidden="true"></i>
              <div class="mb-1" v-for="(item, index) in displayFilters" :key="index">
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for country filter-->
                <template
                  v-if="
                    item.filter_field == 'country' || item.filter_field == 'sourcecountry'
                  "
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="country in item.filter_value"
                    :key="country"
                  >
                    {{
                      countryList.filter((data) => data.countryid === country)[0]
                        ?.countryname
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeCountry(country, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <template v-else-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <template v-else-if="item.filter_field == 'remitgroup'">
                  <span class="badge badge-warning-solid">
                    {{
                      item.filter_value
                        ? remiterOption.filter(
                            (data) => data.groupid == item.filter_value
                          )[0]?.groupname
                        : "-"
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeFilter(index)"
                    ></i>
                  </span>
                </template>
                <template v-else-if="item.filter_field == 'registered'">
                  <span class="badge badge-warning-solid">
                    {{
                      item.filter_value !== undefined && item.filter_value !== null
                        ? registrationStatus.filter(
                            (data) => data.value == item.filter_value
                          )[0]?.name
                        : "-"
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeFilter(index)"
                    ></i>
                  </span>
                </template>
                <template v-else-if="item.filter_field == 'accountstatus'">
                  <span class="badge badge-warning-solid">
                    {{
                      item.filter_value
                        ? accountStatusOptions.filter(
                            (data) => data.value == item.filter_value
                          )[0]?.name
                        : "-"
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeFilter(index)"
                    ></i>
                  </span>
                </template>
                <!-- Other filter -->
                <span class="badge badge-warning-solid" v-else>
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearALLfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div class="py-1 align-items-center justify-content-end table-pagination">
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Remitters List -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="typeof items === 'array' || typeof items === 'object' ? items : []"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              striped
              show-empty
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i v-else-if="sortDesc" class="fa fa-long-arrow-down ml-1"></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(image)="data">
                <!-- <span class="text-danger font-15 font-weight-bold">$</span> limit -->
                <div class="media-object flag-img mr-2">
                  <img
                    v-if="data.item.image"
                    :src="data.item.image"
                    alt=""
                    width="35px"
                    height="35px"
                    class="rounded-circle"
                  />
                  <img
                    v-else-if="data.item.gender == 'Female'"
                    :src="require(`@/assets/xs/female-placeholder.webp`)"
                    alt=""
                    width="35px"
                    class="rounded-circle"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/xs/male-placeholder.webp`)"
                    alt=""
                    width="35px"
                    class="rounded-circle"
                  />
                </div>
              </template>
              <template #cell(location)="data">
                <div class="location-cell">
                  <div
                    v-if="data.item.city && data.item.city != '-'"
                    class="loc-city"
                  >
                    {{ data.item.city }}
                  </div>
                  <div
                    v-if="data.item.state && data.item.state != '-'"
                    class="loc-state"
                  >
                    {{ data.item.state }}
                  </div>
                  <div
                    class="loc-country"
                    v-b-tooltip.hover
                    :title="data.item.country && data.item.country.countryname ? data.item.country.countryname : ''"
                  >
                    <span
                      v-if="data.item.countryCode && data.item.countryCode != '-'"
                      :class="`flag-icon flag-icon-${data.item.countryCode.toLowerCase()} fi-16 fi-round`"
                    ></span>
                    <span class="loc-iso">{{
                      data.item.countryCode && data.item.countryCode != "-"
                        ? data.item.countryCode.toUpperCase()
                        : "-"
                    }}</span>
                  </div>
                </div>
              </template>
              <!-- <template #cell(uuid)="data">
                                <b-button 
                                    id="button1" 
                                    variant="outline-primary" 
                                    size="sm" 
                                    v-b-tooltip.hover
                                    :data-original-title="data.value.id"
                                    :title="data.value.id" 
                                    @click.prevent="copyTooltip($event)">
                                    <i class="fa fa-2x fa-barcode"></i>
                                </b-button>
                            </template> -->
              <template #cell(name)="data">
                <a
                  href="javascript:void(0);"
                  class="font-color"
                  :id="`tooltip${data.index}`"
                  @click="customerDetailModel(data.item)"
                >
                  {{
                    data.item.name
                      ? data.item.name + " " + data.item.mname + " " + data.item.lname
                      : "-"
                  }}
                  <i class="fa fa-ban text-danger" v-if="data.item.blockCustomer"></i>
                  <i class="fa fa-lock text-danger" v-if="data.item.lockedCustomer"></i>
                </a>
                <b-tooltip
                  :target="`tooltip${data.index}`"
                  placement="right"
                  custom-class="customer-tooltip"
                >
                  <h6 class="p-2 border-bottom text-left">
                    Customer Details
                    <!-- <i class="fa fa-exclamation-triangle text-danger"></i> alert -->
                  </h6>
                  <div class="tooltip-body p-2 text-left">
                    <div class="d-flex">
                      <div class="pb-2 label">DOB:</div>
                      <div class="pb-2 value">
                        {{ data.item?.dob ? data.item?.dob : "-" }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">Gender:</div>
                      <div class="pb-2 value">{{ data.item?.gender }}</div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">Referred By:</div>
                      <div class="pb-2 value">
                        {{ data.item.referredby ? data.item.referredby : "-" }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">No of Cards:</div>
                      <div class="pb-2 ml-1">{{ data.item.noOfCard }}</div>
                    </div>
                    <template v-if="data.item.noOfActiveCards != null">
                      <div class="d-flex card-state">
                        <div class="pb-2 label">Active:</div>
                        <div class="pb-2 ml-1 card-state-active">
                          {{ data.item.noOfActiveCards }}
                        </div>
                      </div>
                      <div class="d-flex card-state">
                        <div class="pb-2 label">Deleted:</div>
                        <div class="pb-2 ml-1">
                          {{ data.item.noOfDeletedCards }}
                        </div>
                      </div>
                      <div class="d-flex card-state">
                        <div class="pb-2 label">Blocked:</div>
                        <div class="pb-2 ml-1">
                          {{ data.item.noOfBlockedCards }}
                        </div>
                      </div>
                      <div class="pb-2 card-state-note">
                        A card can be both deleted and blocked, so these may add
                        up to more than the total.
                      </div>
                    </template>
                    <div class="d-flex">
                      <div class="pb-2 label">No of Receivers:</div>
                      <div class="pb-2 ml-1">{{ data.item.noOfReceiver }}</div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">Payangel ID :</div>
                      <div class="pb-2 ml-1">{{ data.item.payangelid }}</div>
                    </div>
                  </div>
                </b-tooltip>
              </template>
              <template #cell(contact)="data">
                <div class="contact-cell">
                  <div class="contact-line">
                    <i class="fa fa-envelope-o contact-ico" aria-hidden="true"></i>
                    <span
                      class="contact-email"
                      v-b-tooltip.hover
                      :title="data.item.email && data.item.email != '-' ? data.item.email : ''"
                      >{{ data.item.email || "-" }}</span
                    >
                    <i
                      class="fa fa-copy contact-copy"
                      v-if="data.item.email && data.item.email != '-'"
                      @click="copyText(data.item.email, 'Email')"
                    ></i>
                  </div>
                  <div class="contact-line">
                    <i class="fa fa-phone contact-ico" aria-hidden="true"></i>
                    <span class="contact-phone">{{ data.item.mobileNumber || "-" }}</span>
                    <i
                      class="fa fa-copy contact-copy"
                      v-if="data.item.mobileNumber && data.item.mobileNumber != '-'"
                      @click="copyText(data.item.mobileNumber, 'Mobile Number')"
                    ></i>
                  </div>
                </div>
              </template>
              <template #cell(accType)="data">
                <img
                  v-if="data.item.accType == 'Basic'"
                  :title="data.item.accType"
                  width="20px"
                  v-b-tooltip.hover
                  :src="require(`@/assets/account-type-svg/plan-basic.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'GREY - Unvalidated Profiles' || data.item.accType == 'Grey'"
                  :title="data.item.accType"
                  width="20px"
                  v-b-tooltip.hover
                  :src="require(`@/assets/account-type-svg/plan-grey-deeper.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Silver'"
                  :title="data.item.accType"
                  width="20px"
                  v-b-tooltip.hover
                  :src="require(`@/assets/account-type-svg/plan-silver.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Silver+'"
                  :title="data.item.accType"
                  width="20px"
                  v-b-tooltip.hover
                  :src="require(`@/assets/account-type-svg/plan-silver-plus.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Bronze'"
                  :title="data.item.accType"
                  width="20px"
                  v-b-tooltip.hover
                  :src="require(`@/assets/account-type-svg/plan-bronze.svg`)"
                />
                <img
                  v-else-if="data.item.accType == 'Red'"
                  :title="data.item.accType"
                  width="20px"
                  v-b-tooltip.hover
                  :src="require(`@/assets/account-type-svg/plan-red.svg`)"
                />
                <span v-else>{{ data.item.accType }}</span>
              </template>
              <template #cell(regdate)="data">
                <span v-if="data.item.registered && data.value !== '-'">
                  {{ data.value | changeDateDDMMYYYY }}
                </span>
                <span v-else>Not Registered</span>
                <span v-if="data.item.deviceType">
                  <i
                    class="fa fa-apple font-14"
                    aria-hidden="true"
                    v-if="data.item.deviceType.toLowerCase() == 'ios'"
                  ></i>
                  <i
                    class="fa fa-android text-success font-14"
                    aria-hidden="true"
                    v-if="data.item.deviceType.toLowerCase() == 'android'"
                  ></i>
                  <!-- <i class="fa fa-user font-14" aria-hidden="true" v-if="data.index == 4"></i>
                                    <i class="fa fa-globe text-info font-14" aria-hidden="true" v-if="data.index == 5"></i> -->
                </span>
              </template>
              <template #cell(idverification)="data">
                <span class="id-verification-container" v-b-tooltip.hover :title="'ID Verification: ' + data.item.idverificationstatus">
                  <i class="fa fa-user-circle id-verification-icon" aria-hidden="true" :class="data.item.idverificationstatus === 'Verified' ? 'text-success' : data.item.idverificationstatus === 'Not Passed' ? 'text-danger' : data.item.idverificationstatus === 'Missing' ? 'text-warning' : 'text-muted'"></i>
                  <i v-if="data.item.idverificationstatus === 'Verified'" class="fa fa-check-circle text-success id-verification-badge" aria-hidden="true"></i>
                  <i v-else-if="data.item.idverificationstatus === 'Not Passed'" class="fa fa-times-circle text-danger id-verification-badge" aria-hidden="true"></i>
                  <i v-else-if="data.item.idverificationstatus === 'Missing'" class="fa fa-exclamation-circle text-warning id-verification-badge" aria-hidden="true"></i>
                </span>
              </template>  
              <template #cell(regStatus)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span class="badge ml-0" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>            
              <template #cell(remitStatus)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span class="badge ml-0" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(linkedRisk)="data">
                <div v-if="data.value && data.value.level" class="linked-risk-cell">
                  <span
                    class="badge"
                    :class="linkedRiskBadgeClass(data.value.level)"
                    v-b-tooltip.hover
                    title="Linked risk level"
                  >
                    {{ data.value.level }}
                  </span>
                  <a
                    v-if="data.value.receiverCount > 0"
                    href="javascript:void(0);"
                    class="d-block lr-sub font-color"
                    @click="showBeneficiary(data)"
                  >
                    View {{ data.value.receiverCount }} receiver{{
                      data.value.receiverCount === 1 ? "" : "s"
                    }}
                  </a>
                  <span v-else class="d-block lr-sub text-muted">No receivers</span>
                  <a
                    href="javascript:void(0);"
                    class="d-block lr-sub text-primary"
                    @click="openLinkedRiskEvidence(data.item)"
                  >
                    Why {{ data.value.level.toLowerCase() }}?
                  </a>
                </div>
                <span
                  v-else-if="data.value && data.value.unavailable"
                  class="text-muted small"
                  v-b-tooltip.hover
                  title="Linked risk could not be calculated"
                  >—</span
                >
                <span v-else class="text-muted small">Calculating…</span>
              </template>
              <template #cell(action)="row">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                  boundary="viewport"
                >
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.edit'])">
                    <b-dropdown-item @click="showEdit(row)">Edit</b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['receiver.view'])">
                    <b-dropdown-item @click="showBeneficiary(row)">
                      View Receivers
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.status'])">
                    <b-dropdown-item
                      v-if="row.item.status == 0 || row.item.status != 1"
                      @click="showChange('Active', row.item)"
                    >
                      Active
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="row.item.status == 1"
                      @click="showChange('Inactive', row.item)"
                    >
                      Inactive
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.enable'])">
                    <b-dropdown-item href="/customer/enable-fields">
                      Enable Fields
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.reset'])">
                    <b-dropdown-item @click="showResetPasswordAlert(row.item)">
                      Reset Password
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.unlock'])">
                    <b-dropdown-item @click="openUnlockLoginModal(row.item)">
                      Unlock Login
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.lock'])">
                    <b-dropdown-item @click="openLockLoginModal(row.item)">
                      Lock Login
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.trust-device'])">
                    <b-dropdown-item @click="openTrustDeviceModal(row.item)">
                      Trust Device
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.delete'])">
                    <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.login'])">
                    <b-dropdown-item @click="openMemberLogin(row.item)">Member Login</b-dropdown-item>
                  </template>
                  <!-- <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.status'])"> -->
                    <b-dropdown-item>Hide</b-dropdown-item>
                  <!-- </template> -->
                  <!-- admin -->
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['remitter.lock'])">
                    <b-dropdown-item @click="showLockAlert">Lock</b-dropdown-item>
                  </template>
                  <!-- admin -->
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="d-flex py-3 align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group label="Per page" label-for="per-page-select" class="mb-0">
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerDetailsModel :customerid="customerDetail" />
    <LinkedRiskEvidenceModal :customer="linkedRiskCustomer" />
    <b-modal
      id="member-login-modal"
      title="Member Login"
      size="xl"
      hide-footer
      scrollable
      v-model="showMemberLoginModal"
    >
      <div v-if="memberLoginUrl" class="member-login-frame">
        <iframe
          :src="memberLoginUrl"
          class="w-100"
          style="border: 0; height: 80vh"
        ></iframe>
      </div>
      <div v-else class="text-muted">Unable to build member login link.</div>
    </b-modal>
    <b-modal
      id="unlock-login-modal"
      title="Unlock Login Lockout"
      hide-footer
      v-model="showUnlockLoginModal"
    >
      <div v-if="unlockStatusLoading" class="text-center py-3">
        <b-spinner small></b-spinner> Checking login-lockout status…
      </div>
      <template v-else>
        <p class="mb-2">
          <strong>Customer:</strong>
          {{ unlockCustomer.name || "-" }}
          <span class="text-muted">({{ unlockCustomer.customer_id }})</span>
        </p>

        <div
          v-if="lockoutStatus && lockoutStatus.isLocked"
          class="alert alert-danger d-flex align-items-start"
        >
          <i class="fa fa-lock mr-2 mt-1"></i>
          <div>
            <div><strong>Currently locked out</strong></div>
            <small>
              Locked until {{ formatLockoutDate(lockoutStatus.lockedUntil) }} ·
              {{ lockoutStatus.attemptCount }} failed attempt(s)
            </small>
          </div>
        </div>
        <div v-else-if="lockoutStatus" class="alert alert-success">
          <i class="fa fa-unlock mr-2"></i>
          This customer is not currently locked out of login — no action needed.
        </div>
        <div v-else class="alert alert-warning">
          Unable to load the login-lockout status. Please close and try again.
        </div>

        <b-form-group
          label="Support reason"
          label-for="unlock-reason"
          description="Required · minimum 3 characters. Recorded in the audit trail."
        >
          <b-form-textarea
            id="unlock-reason"
            v-model="unlockReason"
            rows="2"
            :state="unlockReason.length === 0 ? null : unlockReason.trim().length >= 3"
            :disabled="!(lockoutStatus && lockoutStatus.isLocked)"
            placeholder="e.g. Identity validated over the phone; customer requested unlock."
          ></b-form-textarea>
          <b-form-invalid-feedback :state="unlockReason.length === 0 ? null : unlockReason.trim().length >= 3">
            Reason must be at least 3 characters.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Additional notes (optional)" label-for="unlock-notes">
          <b-form-textarea
            id="unlock-notes"
            v-model="unlockNotes"
            rows="2"
            :disabled="!(lockoutStatus && lockoutStatus.isLocked)"
          ></b-form-textarea>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="mr-2"
            @click="showUnlockLoginModal = false"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            :disabled="
              !(lockoutStatus && lockoutStatus.isLocked) ||
              unlockReason.trim().length < 3 ||
              unlockSubmitting
            "
            @click="submitUnlockLogin"
          >
            <b-spinner small v-if="unlockSubmitting"></b-spinner>
            Unlock Login
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="lock-login-modal"
      title="Lock Login"
      hide-footer
      v-model="showLockLoginModal"
    >
      <div v-if="lockStatusLoading" class="text-center py-3">
        <b-spinner small></b-spinner> Checking login-lockout status…
      </div>
      <template v-else>
        <p class="mb-2">
          <strong>Customer:</strong>
          {{ lockCustomer.name || "-" }}
          <span class="text-muted">({{ lockCustomer.customer_id }})</span>
        </p>

        <div
          v-if="lockStatus && lockStatus.isLocked"
          class="alert alert-danger d-flex align-items-start"
        >
          <i class="fa fa-lock mr-2 mt-1"></i>
          <div>
            <div><strong>Already locked out</strong></div>
            <small>
              Locked until {{ formatLockoutDate(lockStatus.lockedUntil) }} ·
              {{ lockStatus.attemptCount }} failed attempt(s) — no action needed.
            </small>
          </div>
        </div>
        <div v-else-if="lockStatus" class="alert alert-info">
          <i class="fa fa-info-circle mr-2"></i>
          Not currently locked. Locking will block this customer's login for 15 minutes.
        </div>
        <div v-else class="alert alert-warning">
          Unable to load the login-lockout status. Please close and try again.
        </div>

        <b-form-group
          label="Support reason"
          label-for="lock-reason"
          description="Required · minimum 3 characters. Recorded in the audit trail."
        >
          <b-form-textarea
            id="lock-reason"
            v-model="lockReason"
            rows="2"
            :state="lockReason.length === 0 ? null : lockReason.trim().length >= 3"
            :disabled="!(lockStatus && !lockStatus.isLocked)"
            placeholder="e.g. Suspicious activity reported; locking login pending review."
          ></b-form-textarea>
          <b-form-invalid-feedback :state="lockReason.length === 0 ? null : lockReason.trim().length >= 3">
            Reason must be at least 3 characters.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Additional notes (optional)" label-for="lock-notes">
          <b-form-textarea
            id="lock-notes"
            v-model="lockNotes"
            rows="2"
            :disabled="!(lockStatus && !lockStatus.isLocked)"
          ></b-form-textarea>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="mr-2"
            @click="showLockLoginModal = false"
          >
            Cancel
          </b-button>
          <b-button
            variant="danger"
            :disabled="
              !(lockStatus && !lockStatus.isLocked) ||
              lockReason.trim().length < 3 ||
              lockSubmitting
            "
            @click="submitLockLogin"
          >
            <b-spinner small v-if="lockSubmitting"></b-spinner>
            Lock Login
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="trust-device-modal"
      title="Trust Device"
      size="lg"
      hide-footer
      v-model="showTrustDeviceModal"
    >
      <p class="mb-2">
        <strong>Customer:</strong>
        {{ trustCustomer.name || "-" }}
        <span class="text-muted">({{ trustCustomer.customer_id }})</span>
      </p>
      <p class="text-muted small">
        Choose a device this customer has attempted login from (MFA challenge history) or one already
        on their device registry. Trusting affects only that device — it does not disable MFA for the customer.
      </p>

      <b-form-group
        label="Support reason"
        label-for="trust-reason"
        description="Required · minimum 3 characters. Recorded in the audit trail (applies to every trust/revoke action)."
      >
        <b-form-textarea
          id="trust-reason"
          v-model="trustReason"
          rows="2"
          :state="trustReason.length === 0 ? null : trustReason.trim().length >= 3"
          placeholder="e.g. Identity validated over the phone; customer requested this device be trusted."
        ></b-form-textarea>
        <b-form-invalid-feedback :state="trustReason.length === 0 ? null : trustReason.trim().length >= 3">
          Reason must be at least 3 characters.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        label="Support notes (optional)"
        label-for="trust-notes"
        description="Optional · recorded in the audit trail with the CE user who acted."
      >
        <b-form-textarea
          id="trust-notes"
          v-model="trustNotes"
          rows="2"
          placeholder="Additional context for compliance / support review."
        ></b-form-textarea>
      </b-form-group>

      <label class="font-weight-bold d-block mb-1">Devices (registry + login attempts)</label>
      <div v-if="devicesLoading" class="text-center py-3">
        <b-spinner small></b-spinner> Loading devices…
      </div>
      <template v-else>
        <b-table
          v-if="devices.length"
          :items="devices"
          :fields="deviceFields"
          small
          responsive
          class="mb-3"
        >
          <template #cell(status)="row">
            <b-badge :variant="deviceStatus(row.item).variant">
              {{ deviceStatus(row.item).label }}
            </b-badge>
          </template>
          <template #cell(source)="row">
            <span class="small text-muted">{{ deviceSourceLabel(row.item) }}</span>
          </template>
          <template #cell(lastChallengeAt)="row">
            {{ row.item.lastChallengeAt ? formatLockoutDate(row.item.lastChallengeAt) : "-" }}
            <div v-if="row.item.lastChallengeStatus" class="small text-muted">
              {{ row.item.lastChallengeStatus }}
            </div>
          </template>
          <template #cell(trustedAt)="row">
            {{ row.item.trustedAt ? formatLockoutDate(row.item.trustedAt) : "-" }}
          </template>
          <template #cell(lastUsedAt)="row">
            {{ row.item.lastUsedAt ? formatLockoutDate(row.item.lastUsedAt) : "-" }}
          </template>
          <template #cell(action)="row">
            <template v-if="row.item.isTrusted">
              <div class="small text-success mb-1">Already trusted</div>
              <b-button
                size="sm"
                variant="outline-danger"
                :disabled="trustReason.trim().length < 3 || revokingDeviceId === row.item.deviceId"
                @click="submitRevokeDevice(row.item.deviceId)"
              >
                <b-spinner small v-if="revokingDeviceId === row.item.deviceId"></b-spinner>
                Revoke
              </b-button>
            </template>
            <b-button
              v-else-if="row.item.canTrust !== false"
              size="sm"
              variant="primary"
              :disabled="trustReason.trim().length < 3 || trustingDeviceId === row.item.deviceId"
              @click="submitTrustDevice(row.item.deviceId)"
            >
              <b-spinner small v-if="trustingDeviceId === row.item.deviceId"></b-spinner>
              Trust
            </b-button>
            <span v-else class="small text-muted">Cannot trust</span>
          </template>
        </b-table>
        <div v-else class="text-muted mb-3">
          No devices or MFA login attempts on record for this customer yet. Ask the customer to attempt
          login from the device first so it appears here.
        </div>
      </template>
    </b-modal>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
const moment = require("moment");
const LoaderComponent = require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapGetters } from "vuex";
import {
  GET_CUSTOMER_LIST,
  GET_CUSTOMER_INFO,
  UPDATE_CUSTOMER_PERSONAL_DETAILS,
  CUSTOMER_REMITER_GROUPS,
  RESET_CUSTOMER_PASSWORD,
  GET_ACCOUNT_STATUS_LIST,
  GET_LOGIN_LOCKOUT_STATUS,
  UNLOCK_CUSTOMER_LOGIN,
  LOCK_CUSTOMER_LOGIN,
  GET_CUSTOMER_DEVICES,
  TRUST_CUSTOMER_DEVICE,
  REVOKE_CUSTOMER_DEVICE,
  GET_LINKED_RISK_BATCH,
} from "../../../store/actions.type.js"; //GET_CUSTOMER_DETAILS,GET_CUSTOMER_ACCOUNT_DETAILS,GET_CUSTOMER_ADDRESS,
import { ISLOADING } from "../../../store/mutations.type";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
import LinkedRiskEvidenceModal from "./LinkedRiskEvidenceModal.vue";
import { myFunction } from "@/common/common-helper.js";
import "vue-select/dist/vue-select.css";
export default {
  name: "MemberListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    "v-select": () => import("vue-select"),
    Multiselect: () => import("vue-multiselect"),
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
    LinkedRiskEvidenceModal,
  },
  methods: {
    async getremiterGroup() {
      this.$store.dispatch(CUSTOMER_REMITER_GROUPS).then((response) => {
        if (response.status == 200) {
          this.remiterOption = response.data.details;
        }
      });
    },
    async getAccountStatuses() {
      this.$store.dispatch(GET_ACCOUNT_STATUS_LIST).then((response) => {
        if (response.status == 200) {
          this.accountStatusOptions = response.data.details.map(status => ({
            value: status.category,
            name: status.name
          }));
        }
      });
    },
    // for openFilters
    openFilters() {
      this.cookieFilters();
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: { id: "firstname", name: "First Name", $isDisabled: true },
            search: "",
            country: [],
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter((data) => data.id == item.field.id)[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter((data) => data.$isDisabled == false)[0],
          search: "",
          country: [],
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter((data) => data.id == item.field.id)[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      let fieldid = this.advanceFilters[index].field.id
        ? this.advanceFilters[index].field.id
        : this.displayFilters[index].filter_field;
      this.filterField.filter((data) => data.id == fieldid)[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      if (this.displayFilters.length == 0) {
        this.getCustomerList();
      }
      this.$cookies.set("remitter-list-filter", this.displayFilters);
    },
    // remove country filters
    removeCountry(country, field, filterindex) {
      let temp = this.displayFilters.filter((data) => data.filter_field == field)[0]
        .filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.countryList.filter((data) => data.countryid === item)[0]
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$store.commit(ISLOADING, true);
      this.getCustomerList();
      this.$cookies.set("remitter-list-filter", this.displayFilters);
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("remitter-list-filter", this.displayFilters);
      this.$store.commit(ISLOADING, true);
      this.getCustomerList();
    },

    // apply filters
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (
          item.field.id == "firstname" ||
          item.field.id == "middlename" ||
          item.field.id == "lastname" ||
          item.field.id == "address" ||
          item.field.id == "ipaddress" ||
          item.field.id == "state" ||
          item.field.id == "city"
        ) {
          data.filter_value = item.search;
        }
        if (item.field.id == "country" || item.field.id == "sourcecountry") {
          let countries = [];
          item.country.map((country) => {
            countries.push(country.countryid);
          });
          data.filter_value = countries;
        }
        if (item.field.id == "remitstatus") {
          data.filter_value = item.search.value;
        }
        if (item.field.id == "idverificationstatus") {
          data.filter_value = item.search.value;
        } 
        if (item.field.id == "remitgroup") {
          data.filter_value = item.search.groupid;
        }
        if (item.field.id == "registered") {
          data.filter_value = item.search.value;
        }
        if (item.field.id == "accountstatus") {
          data.filter_value = item.search.value;
        }
        if (item.field.id == "date") {
          if (item.date.from && item.date.to) {
            data.filter_value = {
              from: moment(item.date.from).format("YYYY-MM-DD"),
              to: moment(item.date.to).format("YYYY-MM-DD"),
            };
          } else if (item.date.from) {
            data.filter_value = {
              from: moment(item.date.from).format("YYYY-MM-DD"),
            };
          } else if (item.date.to) {
            data.filter_value = {
              to: moment(item.date.to).format("YYYY-MM-DD"),
            };
          }
        }
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("remitter-list-filter", params);
      this.displayFilters = this.$cookies.get("remitter-list-filter");
      // console.log('params',params);
    },

    // clear filters
    clearALLfilter() {
      this.advanceFilters = [
        {
          field: { id: "firstname", name: "First Name", $isDisabled: true },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
          amount: {
            type: "",
            value: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("remitter-list-filter", this.displayFilters);
      this.$store.commit(ISLOADING, true);
      this.getCustomerList();
    },
    customerDetailModel(item) {
      this.customerDetail = item;
      setTimeout(() => {
        this.$bvModal.show("customer-details");
      }, 100);
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "The remitter has been deleted.",
              "success"
            );
          }
        });
    },
    showLockAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to lock this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, lock it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Locked!",
              "The remitter has been Locked.",
              "success"
            );
          }
        });
    },

    showResetPasswordAlert(customer) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to reset the password for this customer?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, reset it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(RESET_CUSTOMER_PASSWORD, customer.customer_id)
              .then((response) => {
                if (response.status == 200) {
                  swalWithBootstrapButtons.fire(
                    "Success!",
                    "The customer password has been reset successfully.",
                    "success"
                  );
                } else {
                  swalWithBootstrapButtons.fire(
                    "Error!",
                    response?.data?.message ||
                      "Failed to reset password. Please try again.",
                    "error"
                  );
                }
              })
              .catch(() => {
                swalWithBootstrapButtons.fire(
                  "Error!",
                  "Failed to reset password. Please try again.",
                  "error"
                );
              });
          }
        });
    },

    // Open the unlock-login modal and fetch the customer's current login-lockout status so CE can
    // clearly see whether the account is locked before submitting the (permission-gated) unlock.
    openUnlockLoginModal(customer) {
      this.unlockCustomer = customer;
      this.lockoutStatus = null;
      this.unlockReason = "";
      this.unlockNotes = "";
      this.unlockSubmitting = false;
      this.unlockStatusLoading = true;
      this.showUnlockLoginModal = true;

      this.$store
        .dispatch(GET_LOGIN_LOCKOUT_STATUS, customer.customer_id)
        .then((response) => {
          if (response && response.status == 200) {
            this.lockoutStatus = response.data;
          } else {
            this.lockoutStatus = null;
            myFunction.showInfo(
              response?.data?.message || "Failed to load login-lockout status.",
              "error"
            );
          }
        })
        .catch(() => {
          this.lockoutStatus = null;
          myFunction.showInfo("Failed to load login-lockout status.", "error");
        })
        .finally(() => {
          this.unlockStatusLoading = false;
        });
    },

    submitUnlockLogin() {
      if (!(this.lockoutStatus && this.lockoutStatus.isLocked) || this.unlockReason.trim().length < 3) {
        return;
      }
      this.unlockSubmitting = true;
      this.$store
        .dispatch(UNLOCK_CUSTOMER_LOGIN, {
          customerId: this.unlockCustomer.customer_id,
          reason: this.unlockReason.trim(),
          notes: this.unlockNotes.trim() || undefined,
        })
        .then((response) => {
          if (response && response.status == 200) {
            this.showUnlockLoginModal = false;
            this.$swal.fire(
              "Unlocked!",
              "The customer's login lockout has been cleared. They can attempt login again immediately.",
              "success"
            );
          } else if (response && response.status == 400) {
            // Business "not locked" (message set) vs a validation error (detail only).
            if (this.lockoutStatus && response?.data?.message) {
              this.lockoutStatus.isLocked = false;
            }
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "This customer is not currently locked out.",
              "error"
            );
          } else if (response && response.status == 404) {
            myFunction.showInfo(
              response?.data?.message || response?.data?.detail || "Customer not found.",
              "error"
            );
          } else {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "Failed to unlock the customer. Please try again.",
              "error"
            );
          }
        })
        .catch(() => {
          myFunction.showInfo(
            "Failed to unlock the customer. Please try again.",
            "error"
          );
        })
        .finally(() => {
          this.unlockSubmitting = false;
        });
    },

    // Open the lock-login modal and fetch the current status so CE can see whether the account is
    // already locked (in which case there is nothing to do) before applying a manual lock.
    openLockLoginModal(customer) {
      this.lockCustomer = customer;
      this.lockStatus = null;
      this.lockReason = "";
      this.lockNotes = "";
      this.lockSubmitting = false;
      this.lockStatusLoading = true;
      this.showLockLoginModal = true;

      this.$store
        .dispatch(GET_LOGIN_LOCKOUT_STATUS, customer.customer_id)
        .then((response) => {
          if (response && response.status == 200) {
            this.lockStatus = response.data;
          } else {
            this.lockStatus = null;
            myFunction.showInfo(
              response?.data?.message || "Failed to load login-lockout status.",
              "error"
            );
          }
        })
        .catch(() => {
          this.lockStatus = null;
          myFunction.showInfo("Failed to load login-lockout status.", "error");
        })
        .finally(() => {
          this.lockStatusLoading = false;
        });
    },

    submitLockLogin() {
      if (!(this.lockStatus && !this.lockStatus.isLocked) || this.lockReason.trim().length < 3) {
        return;
      }
      this.lockSubmitting = true;
      this.$store
        .dispatch(LOCK_CUSTOMER_LOGIN, {
          customerId: this.lockCustomer.customer_id,
          reason: this.lockReason.trim(),
          notes: this.lockNotes.trim() || undefined,
        })
        .then((response) => {
          if (response && response.status == 200) {
            this.showLockLoginModal = false;
            this.$swal.fire(
              "Locked!",
              "The customer's login has been locked. They cannot log in until it is cleared or the lockout expires.",
              "success"
            );
          } else if (response && response.status == 400) {
            // Business "already locked" (message set) vs a validation error (detail only).
            if (this.lockStatus && response?.data?.message) {
              this.lockStatus.isLocked = true;
            }
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "This customer's login is already locked.",
              "error"
            );
          } else if (response && response.status == 404) {
            myFunction.showInfo(
              response?.data?.message || response?.data?.detail || "Customer not found.",
              "error"
            );
          } else {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "Failed to lock the customer. Please try again.",
              "error"
            );
          }
        })
        .catch(() => {
          myFunction.showInfo(
            "Failed to lock the customer. Please try again.",
            "error"
          );
        })
        .finally(() => {
          this.lockSubmitting = false;
        });
    },

    // Open the trust-device modal and load the customer's devices so CE can clearly see which are
    // already trusted before submitting a (permission-gated) trust.
    openTrustDeviceModal(customer) {
      this.trustCustomer = customer;
      this.devices = [];
      this.trustReason = "";
      this.trustNotes = "";
      this.trustingDeviceId = null;
      this.revokingDeviceId = null;
      this.showTrustDeviceModal = true;
      this.fetchCustomerDevices();
    },

    fetchCustomerDevices() {
      this.devicesLoading = true;
      this.$store
        .dispatch(GET_CUSTOMER_DEVICES, this.trustCustomer.customer_id)
        .then((response) => {
          if (response && response.status == 200) {
            this.devices = (response.data && response.data.devices) || [];
          } else {
            this.devices = [];
            myFunction.showInfo(
              response?.data?.message || "Failed to load devices.",
              "error"
            );
          }
        })
        .catch(() => {
          this.devices = [];
          myFunction.showInfo("Failed to load devices.", "error");
        })
        .finally(() => {
          this.devicesLoading = false;
        });
    },

    deviceStatus(device) {
      if (device.isTrusted) return { label: "Already trusted", variant: "success" };
      if (device.revokedAt) return { label: "Revoked", variant: "warning" };
      if (device.source === "mfa_challenge") return { label: "Login attempt", variant: "info" };
      return { label: "Not trusted", variant: "secondary" };
    },

    deviceSourceLabel(device) {
      if (device.source === "both") return "Registry + MFA challenge";
      if (device.source === "mfa_challenge") return "MFA login attempt";
      return "Device registry";
    },

    submitTrustDevice(deviceId) {
      if (!deviceId || this.trustReason.trim().length < 3) return;
      const selected = this.devices.find((d) => d.deviceId === deviceId);
      if (selected && selected.isTrusted) {
        myFunction.showInfo("This device is already trusted.", "error");
        return;
      }
      this.trustingDeviceId = deviceId;
      this.$store
        .dispatch(TRUST_CUSTOMER_DEVICE, {
          customerId: this.trustCustomer.customer_id,
          deviceId: deviceId,
          reason: this.trustReason.trim(),
          notes: this.trustNotes.trim() || undefined,
        })
        .then((response) => {
          if (response && response.status == 200) {
            this.$swal.fire(
              "Device trusted!",
              "The device is now trusted. The customer can log in from it without an MFA challenge.",
              "success"
            );
            this.fetchCustomerDevices();
          } else if (response && response.status == 409) {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "This device is registered to a different customer.",
              "error"
            );
          } else if (response && response.status == 400) {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "This device cannot be trusted.",
              "error"
            );
            if (response?.data?.message) this.fetchCustomerDevices();
          } else if (response && response.status == 404) {
            myFunction.showInfo(
              response?.data?.message || response?.data?.detail || "Customer not found.",
              "error"
            );
          } else {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "Failed to trust the device. Please try again.",
              "error"
            );
          }
        })
        .catch(() => {
          myFunction.showInfo(
            "Failed to trust the device. Please try again.",
            "error"
          );
        })
        .finally(() => {
          this.trustingDeviceId = null;
        });
    },

    submitRevokeDevice(deviceId) {
      if (!deviceId || this.trustReason.trim().length < 3) return;
      this.revokingDeviceId = deviceId;
      this.$store
        .dispatch(REVOKE_CUSTOMER_DEVICE, {
          customerId: this.trustCustomer.customer_id,
          deviceId: deviceId,
          reason: this.trustReason.trim(),
          notes: this.trustNotes.trim() || undefined,
        })
        .then((response) => {
          if (response && response.status == 200) {
            this.$swal.fire(
              "Trust revoked!",
              "The device is no longer trusted. The customer will be asked for MFA on their next login from it.",
              "success"
            );
            this.fetchCustomerDevices();
          } else if (response && response.status == 409) {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "This device is registered to a different customer.",
              "error"
            );
          } else if (response && response.status == 400) {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "This device is not currently trusted.",
              "error"
            );
            if (response?.data?.message) this.fetchCustomerDevices();
          } else if (response && response.status == 404) {
            myFunction.showInfo(
              response?.data?.message || response?.data?.detail || "Device or customer not found.",
              "error"
            );
          } else {
            myFunction.showInfo(
              response?.data?.message ||
                response?.data?.detail ||
                "Failed to revoke the device. Please try again.",
              "error"
            );
          }
        })
        .catch(() => {
          myFunction.showInfo(
            "Failed to revoke the device. Please try again.",
            "error"
          );
        })
        .finally(() => {
          this.revokingDeviceId = null;
        });
    },

    formatLockoutDate(value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "-";
    },

    openMemberLogin(remitter) {
      const token = localStorage.getItem("jwtToken") || "";
      const firstName = remitter.name && remitter.name !== "-" ? remitter.name : "";

      const contact = this.getContact(remitter);
      if (!contact.value) {
        myFunction.showInfo("No email or mobile found for this remitter.", "error");
        return;
      }
      if (!token) {
        myFunction.showInfo("Missing auth token. Please re-login.", "error");
        return;
      }

      const params = new URLSearchParams();
      if (contact.type === "email" && contact.value) {
        params.append("email", contact.value);
      } else if (contact.type === "mobile" && contact.value) {
        params.append("mobile", contact.value);
      } else if (contact.type === "both" && contact.value) {
        if (contact.value === contact.email) {
          params.append("email", contact.value);
        } else if (contact.value === contact.mobile) {
          params.append("mobile", contact.value);
        }
      }
      if (firstName) params.append("first_name", firstName);
      params.append("token", token);

      const payangelBaseUrl = process.env.VUE_APP_MOBILE_APP_URL;
      if (!payangelBaseUrl || payangelBaseUrl === "undefined") {
        myFunction.showInfo("PayAngel URL is not configured. Please set VUE_APP_MOBILE_APP_URL environment variable.", "error");
        return;
      }

      this.memberLoginUrl = `${payangelBaseUrl}/?${params.toString()}`;
            
      this.showMemberLoginModal = true;
      this.$nextTick(() => {
        this.$bvModal.show("member-login-modal");
      });
    },

    getContact(remitter) {
      const email = remitter.email && remitter.email !== "-" ? remitter.email : "";
      const mobile = remitter.mobileNumber && remitter.mobileNumber !== "-" ? remitter.mobileNumber : "";
      const isEmailVerified = remitter.is_email_verified === true;
      const isMobileVerified = remitter.is_mobile_verified === true;

      if (email && mobile) {
        if (isEmailVerified) {
          return { type: "both", email, mobile, value: email };
        }
        if (isMobileVerified) {
          return { type: "both", email, mobile, value: mobile };
        }
        return { type: "both", email, mobile, value: email };
      }
      if (email) {
        return { type: "email", value: email };
      }
      if (mobile) {
        return { type: "mobile", value: mobile };
      }

      return { type: "none", value: "" };
    },

    showChange(status, data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to change this status " + status + " !",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let params = {
              id: data.id,
              status: status == "Active" ? 1 : 0,
            };

            this.$store
              .dispatch(UPDATE_CUSTOMER_PERSONAL_DETAILS, params)
              .then((response) => {
                if (response.status == 200) {
                  swalWithBootstrapButtons.fire(
                    "Success!",
                    "Your status has been changed successfully.",
                    "success"
                  );
                }
              });
          }
        });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    //Recent transactions table Details copy
    copyTooltip: function (e) {
      var tooltipText = e.currentTarget.getAttribute("data-original-title");
      const inputCopyText = document.createElement("input");
      inputCopyText.value = tooltipText;
      document.body.appendChild(inputCopyText);
      inputCopyText.select();
      document.execCommand("copy");
      document.body.removeChild(inputCopyText);
    },

    showEdit(data) {
      // console.log(data.item.id);
      this.$router.push({
        name: "customer-edit",
        params: {
          customer_id: this.$CryptoJS.AES.encrypt(
            data.item.customer_id,
            "customer_id"
          ).toString(),
        },
      });
    },

    showBeneficiary(data) {
      this.$router.push({
        path: "/beneficiary/all",
        query: {
          customer_id: this.$CryptoJS.AES.encrypt(
            data.item.customer_id,
            "customer_id"
          ).toString(),
        },
      });
    },

    async getCustomerList() {
      let page = "";
      let page_size = "";
      let sortby = "";
      let sort = false;
      this.items = [];
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        page_size = this.perPage;
      } else {
        page_size = 10;
      }
      if (this.sortBy == "") {
        sortby = "createdAt";
      } else if (this.sortBy == "name") {
        sortby = "firstname";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "DESC";
      } else {
        sort = "ASC";
      }

      this.currentPageJump = page;
      const tempitems = [];
      // console.log(fromdate);
      let tempparam = `?sort=${sort}&sortby=${sortby}&size=${page_size}&page=${page}`;
      const trimmedKeywords = this.search_keywords ? this.search_keywords.trim() : "";
      if (trimmedKeywords) {
        tempparam = tempparam + `&search=${trimmedKeywords}`;
      }
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          if (item.filter_field == "date") {
            if (item.filter_value.from) {
              tempparam = tempparam + `&regstartdate=${item.filter_value.from}`;
            }
            if (item.filter_value.to) {
              tempparam = tempparam + `&reglastdate=${item.filter_value.to}`;
            }
          } else if (item.filter_field == "country") {
            tempparam = tempparam + `&countries[]=${item.filter_value}`;
          } else {
            tempparam = tempparam + `&${item.filter_field}=${item.filter_value}`;
          }
        });
      }
      await this.$store.dispatch(GET_CUSTOMER_LIST, tempparam).then((response) => {
        if (response.status == 200) {
          response.data.details.map((item) => {
            let statusobj = "";
            if (item.accountStatus.toLowerCase() === "active") {
              statusobj = { name: "Active", class: "badge-success" };
            } else if (item.accountStatus.toLowerCase() === "inactive") {
              statusobj = { name: "In Active", class: "badge-warning" };
            } else if (item.accountStatus.toLowerCase() === "locked out") {
              statusobj = { name: "Locked Out", class: "badge-danger" };
            } else {
              statusobj = { name: "Disabled", class: "badge-grey" };
            }
            let countryObj = item.country
              ? this.countryList.filter((data) => data.countryname === item.country)[0]
              : null;

            let identificationStatus = "";
            if(item.idverificationstatus){
              if(item.idverificationstatus.toLowerCase() == 'passed'){
                identificationStatus = "Verified";
              } else if(item.idverificationstatus.toLowerCase() == 'refer'){
                identificationStatus = "Not Passed";
              } else {
                identificationStatus = "Missing";
              }
            } else {
              identificationStatus = "Missing";
            }

            let regstatusobj = "";
            if (item.registered == 2) {
              regstatusobj = { name: "Registered", class: "badge-success" };
            } else if (item.registered === 1) {
              regstatusobj = { name: "In Progress", class: "badge-info" };
            } else if (item.registered === 0) {
              regstatusobj = { name: "Not Registered", class: "badge-danger" };
            } else {
              regstatusobj = { name: "Incomplete", class: "badge-grey" };
            }

            let customerLists = {
              customer_id: item.id,
              uuid: { id: item.id },
              image: item.image,
              dob: item.dob,
              name: item.firstname != null ? item.firstname : "",
              mname: item.middlename != null ? item.middlename : "",
              lname: item.lastname != null ? item.lastname : "",
              city: item.city ? item.city : "-",
              state: item.state ? item.state : "-",
              regdate: item.registerdate ? item.registerdate : "-",
              registered: item.registered,
              regStatus: regstatusobj,
              country: countryObj || "-",
              countryCode: countryObj?.isocode || "-",
              mobileNumber: item.phone ? item.phone : "-",
              email: item.email ? item.email : "-",
              accType: item.account_type ? item.account_type : "-",
              payangelid: item.payangelid ? item.payangelid : "-",
              remitStatus: statusobj,
              status: item.status,
              gender: item.gender ? item.gender : "-",
              noOfCard: item.noOfCard,
              // ENG-2174: left undefined when the backend predates ENG-2172, so the
              // popover hides the breakdown rather than claiming a misleading zero.
              noOfActiveCards: item.noOfActiveCards,
              noOfDeletedCards: item.noOfDeletedCards,
              noOfBlockedCards: item.noOfBlockedCards,
              noOfReceiver: item.noOfReceiver,
              referredby: item.referredby,
              deviceType: item.deviceType,
              blockCustomer: item.blockCustomer,
              lockedCustomer: item.lockedCustomer,
              id_number: item.id_number,
              id_details: item.id_details,
              idverificationstatus: identificationStatus,
              is_email_verified: item.is_email_verified ?? false,
              is_mobile_verified: item.is_mobile_verified ?? false,
              linkedRisk: null,
              action: "",
            };
            tempitems.push(customerLists);
          });
          // this.perPage = response.data.results.length;
          this.totalRows = response.data.query.total;
          this.items = tempitems;
          this.fetchLinkedRisk();
        }
      });
    },
    // Fetch linked-risk summaries for the remitters on the current page.
    // The list page can show up to 1000 rows, but the backend caps each batch
    // request at 50 ids, so split into chunks and run them a few at a time to
    // avoid overwhelming the (currently unindexed) matching queries.
    async fetchLinkedRisk() {
      const requestItems = this.items;
      const customerIds = requestItems
        .map((item) => item.customer_id)
        .filter((id) => !!id);
      if (customerIds.length === 0) {
        return;
      }

      const CHUNK_SIZE = 50;
      const MAX_CONCURRENT = 3;
      const chunks = [];
      for (let i = 0; i < customerIds.length; i += CHUNK_SIZE) {
        chunks.push(customerIds.slice(i, i + CHUNK_SIZE));
      }

      const merged = {};
      for (let i = 0; i < chunks.length; i += MAX_CONCURRENT) {
        const wave = chunks.slice(i, i + MAX_CONCURRENT);
        // eslint-disable-next-line no-await-in-loop
        await Promise.all(
          wave.map((chunk) =>
            this.$store
              .dispatch(GET_LINKED_RISK_BATCH, chunk)
              .then((response) => {
                if (response && response.status == 200 && response.data.details) {
                  Object.assign(merged, response.data.details);
                }
              })
              .catch(() => {})
          )
        );
      }

      // Guard against the list having been replaced (new page/search) mid-flight.
      if (this.items !== requestItems) {
        return;
      }
      this.items.forEach((item, index) => {
        const summary = merged[item.customer_id];
        this.$set(
          this.items[index],
          "linkedRisk",
          summary || { unavailable: true }
        );
      });
    },
    openLinkedRiskEvidence(item) {
      this.linkedRiskCustomer = {
        id: item.customer_id,
        name: [item.name, item.mname, item.lname].filter(Boolean).join(" "),
      };
      // Wait for the prop to propagate to the modal before opening, so its
      // @show handler sees the selected remitter rather than a stale/empty value.
      this.$nextTick(() => {
        this.$bvModal.show("linked-risk-evidence-modal");
      });
    },
    linkedRiskBadgeClass(level) {
      // Readable soft-filled pills (green/amber/red) for consistency across risk views.
      return "risk-pill risk-" + (level ? level.toLowerCase() : "low");
    },
    searchCustomer() {
      this.$store.commit(ISLOADING, true);
      this.getCustomerList();
    },

    refreshCustomerTable() {
      this.$refs.customerTable?.refresh();
    },

    resetFilterValue() {
      this.search.fname = "";
      this.search.mname = "";
      this.search.lname = "";
      this.search.rgroup = null;
      this.search.rstatus = null;
      this.search.country = null;
      this.search.from = "";
      this.search.to = "";
      this.currentPage = 1;
      this.refreshCustomerTable();
    },
    //Set filters in cookies
    async cookieFilters() {
      // this.displayFilters = this.$cookies.get('remitter-list-filter') != null ? this.$cookies.get('remitter-list-filter') : [];
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field
          )[0].$isDisabled = true;
          if (
            item.filter_field == "firstname" ||
            item.filter_field == "middlename" ||
            item.filter_field == "lastname" ||
            item.filter_field == "address" ||
            item.field == "ipaddress" ||
            item.field == "state" ||
            item.field == "city"
          ) {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: item.filter_value,
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "remitstatus") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: this.remiterStatus.filter(
                (data) => data.value == item.filter_value
              )[0],
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "idverificationstatus") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: this.idVerificationStatus.filter(
                (data) => data.value == item.filter_value
              )[0],
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "remitgroup") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: this.remiterOption.filter(
                (data) => data.groupid == item.filter_value
              )[0],
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "registered") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: this.registrationStatus.filter(
                (data) => data.value == item.filter_value
              )[0],
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "accountstatus") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: this.accountStatusOptions.filter(
                (data) => data.value == item.filter_value
              )[0],
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "country" || item.filter_field == "sourcecountry") {
            let countries = [];
            item.filter_value.map((country) => {
              countries.push(
                this.countryList.filter((data) => data.countryid === country)[0]
              );
            });
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: "",
              country: countries,
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
          if (item.filter_field == "date") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter((data) => data.id == item.filter_field)[0]
                  .name,
                $isDisabled: true,
              },
              search: "",
              country: [],
              date: {
                from: item.filter_value.from,
                to: item.filter_value.to,
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
        });
        this.advanceFilters = filters;
      }
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.sortBy != "") {
        this.$store.commit(ISLOADING, true);
        this.getCustomerList();
      }
    },
  },
  data() {
    return {
      breadCrumbIteams: [
        {
          title: "Remitter",
          links: "",
        },
        {
          title: "Remitter List",
          links: "",
        },
      ],
      filterField: [
        { id: "firstname", name: "First Name", $isDisabled: false },
        { id: "middlename", name: "Middle Name", $isDisabled: false },
        { id: "lastname", name: "Last Name", $isDisabled: false },
        { id: "country", name: "Country", $isDisabled: false },
        // { id: 'state', name: 'State' ,$isDisabled:false},
        // { id: 'city', name: 'City' ,$isDisabled:false},
        { id: "date", name: "Regn. Date", $isDisabled: false },
        { id: "remitstatus", name: "Remitter Status", $isDisabled: false },
        { id: "idverificationstatus", name: "ID Verification Status", $isDisabled: false },
        { id: "remitgroup", name: "Remitter Group", $isDisabled: false },
        { id: "registered", name: "Registration Status", $isDisabled: false },
        { id: "accountstatus", name: "Account Status", $isDisabled: false },
        { id: "ipaddress", name: "Registered IP", $isDisabled: false },
        { id: "address", name: "Address", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "firstname", name: "First Name", $isDisabled: false },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
        },
      ],
      displayFilters: [],
      customerInfo: {
        total: 0,
        today: 0,
        month: 0,
        valid: 0,
      },
      customerDetail: null,
      linkedRiskCustomer: null,
      items: [],
      fields: [
        {
          key: "image",
          label: "Profile image",
          sortable: false,
          thClass: "th_sortfix",
          thStyle: { width: "10%" },
        },
        // { key: 'journyid', label: 'Journy ID',sortable: true,thClass:'th_sortfix'},
        {
          key: "name",
          label: "Name",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "10%" },
          tdClass: "white-space-normal",
        },
        {
          key: "contact",
          label: "Contact",
          sortable: false,
          thClass: "th_sortfix",
          thStyle: { width: "16%" },
          tdClass: "contact-td",
        },
        {
          key: "location",
          label: "Location",
          sortable: false,
          thStyle: { width: "11%" },
          thClass: "th_sortfix",
        },
        // { key: 'country', label: 'Country',sortable: true, thStyle:{width:'10%'},thClass:'th_sortfix'},
        {
          key: "regdate",
          label: "Regn. Date",
          sortable: true,
          thStyle: { width: "15%" },
          thClass: "th_sortfix",
        },
        {
          key: "idverification",
          label: "ID Verification",
          sortable: true,
          thStyle: { width: "15%" },
          thClass: "th_sortfix",
        },
        {
          key: "regStatus",
          label: "Regn. Status",
          sortable: false,
          thStyle: { width: "15%" },
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "accType",
          label: "Acc. Type",
          sortable: false,
          thClass: "th_sortfix",
          thStyle: { width: "5%" },
          tdClass: "white-space-normal text-center",
        },
        {
          key: "remitStatus",
          label: "Acc. Status",
          sortable: false,
          thStyle: { width: "15%" },
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "linkedRisk",
          label: "Linked Risk",
          sortable: false,
          thStyle: { width: "12%" },
          thClass: "th_sortfix",
          tdClass: "white-space-normal",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "regdate",
      sortDesc: true,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',

      transactions_toprows: [],
      totalCustomers: 0,

      isVisibleFilter: false,
      search_keywords: "",

      search: {
        from: "",
        to: "",
        fname: "",
        mname: "",
        lname: "",
        rgroup: null,
        rstatus: null,
        country: null,
        keywords: "",
      },

      remiterOption: [],
      remiterStatus: [
        { value: "Valid", name: "Valid" },
        { value: "Blocked", name: "Blocked" },
        { value: "Expired", name: "Expired" },
      ],
      idverificationStatus: [
        { value: "passed", name: "Verified" },
        { value: "refer", name: "Not Passed" },
        { value: "missing", name: "Missing" },
      ],
      registrationStatus: [
        { value: 0, name: "Not registered" },
        { value: 1, name: "Registration in progress" },
        { value: 2, name: "Registered" },
      ],
      accountStatusOptions: [],
      showMemberLoginModal: false,
      memberLoginUrl: "",
      showUnlockLoginModal: false,
      unlockCustomer: {},
      lockoutStatus: null,
      unlockStatusLoading: false,
      unlockSubmitting: false,
      unlockReason: "",
      unlockNotes: "",
      showLockLoginModal: false,
      lockCustomer: {},
      lockStatus: null,
      lockStatusLoading: false,
      lockSubmitting: false,
      lockReason: "",
      lockNotes: "",
      showTrustDeviceModal: false,
      trustCustomer: {},
      devices: [],
      devicesLoading: false,
      trustReason: "",
      trustNotes: "",
      trustingDeviceId: null,
      revokingDeviceId: null,
      deviceFields: [
        { key: "deviceId", label: "Device ID" },
        { key: "status", label: "Status" },
        { key: "source", label: "Source" },
        { key: "lastChallengeAt", label: "Last login attempt" },
        { key: "trustedAt", label: "Trusted at" },
        { key: "lastUsedAt", label: "Last used" },
        { key: "action", label: "" },
      ],
    };
  },
  async mounted() {
    this.totalRows = this.items.length;
    await this.getremiterGroup();
    await this.getAccountStatuses();
    // await this.cookieFilters();
    this.displayFilters =
      this.$cookies.get("remitter-list-filter") != null
        ? this.$cookies.get("remitter-list-filter")
        : [];

    // Always load customer list on initial mount
    this.$store.commit(ISLOADING, true);
    this.getCustomerList();
    // setInterval(() => {
    //     if(this.$route.path == '/customer/list'){
    //         this.getCustomerList();
    //     }
    // }, 30000); // 30 sec (30000)
    this.$store.dispatch(GET_CUSTOMER_INFO).then((response) => {
      if (response.status == 200) {
        this.totalCustomers = response.data.query.total_customers ?? 0;
        this.customerInfo = {
          today: response.data.query.new_customers_today ?? 0,
          month: response.data.query.new_customers_this_month ?? 0,
          total: response.data.query.total_customers ?? 0,
          valid: response.data.query.valid_customers ?? 0,
        };
      }
    });

    // Deep-link: when opened with ?linkedRiskId=<enc customer id> (e.g. from the "Why?"
    // link on the remitter account page), auto-open that remitter's linked-risk evidence.
    if (this.$route.query.linkedRiskId) {
      try {
        const id = this.$CryptoJS.AES.decrypt(
          this.$route.query.linkedRiskId,
          "customer_id"
        ).toString(this.$CryptoJS.enc.Utf8);
        if (id) {
          this.linkedRiskCustomer = { id, name: this.$route.query.riskName || "" };
          this.$nextTick(() => this.$bvModal.show("linked-risk-evidence-modal"));
        }
      } catch (e) {
        // ignore a malformed deep-link param
      }
    }
  },
  watch: {
    displayFilters() {
      if (
        this.$cookies.get("remitter-list-filter") != null &&
        this.displayFilters.length > 0
      ) {
        this.$store.commit(ISLOADING, true);
        this.getCustomerList();
      }
    },
    currentPage: {
      handler: function () {
        this.$store.commit(ISLOADING, true);
        this.getCustomerList();
      },
    },
    perPage: {
      handler: function () {
        this.$store.commit(ISLOADING, true);
        this.getCustomerList();
      },
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
};
</script>
<style scoped>
/* Readable risk pills (green/amber/red) — compact. */
.risk-pill {
  display: inline-block;
  border: 1px solid;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.risk-pill.risk-low {
  color: #256a37;
  border-color: #9ccaa9;
  background: #eef8f1;
}
.risk-pill.risk-medium {
  color: #8a6d00;
  border-color: #e2c15a;
  background: #fdf6e3;
}
.risk-pill.risk-high {
  color: #a72727;
  border-color: #e2a1a1;
  background: #fdeeee;
}
.linked-risk-banner {
  background: #f1fffb;
  border: 1px solid #bdeee3;
  border-left: 4px solid #49d9bd;
  color: #1b4f45;
  font-size: 13px;
}
.linked-risk-cell {
  line-height: 1.3;
}
.linked-risk-cell .lr-sub {
  font-size: 10.5px;
  font-weight: 600;
  margin-top: 2px;
}
/* Compact the whole remitters table (denser rows + slightly smaller text) so the
   wide column set — including the Linked Risk column — fits without overflow. */
::v-deep .table-custom th,
::v-deep .table-custom td {
  padding: 0.4rem 0.45rem;
  font-size: 12.5px;
  vertical-align: middle;
}
::v-deep .table-custom th {
  font-size: 12px;
  white-space: nowrap;
}
/* Stacked Contact column: email on top (truncated + tooltip), mobile below (full, no wrap). */
::v-deep .contact-td {
  white-space: nowrap;
}
.contact-cell {
  line-height: 1.35;
  max-width: 230px;
}
.contact-line {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.contact-line + .contact-line {
  margin-top: 2px;
}
.contact-ico {
  color: #8a97a3;
  width: 13px;
  text-align: center;
  flex-shrink: 0;
}
/* Email: single line; sits next to its copy icon and only shrinks+ellipsis when it
   would exceed the cell width (full value in the hover tooltip). */
.contact-email {
  flex: 0 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Mobile: always shown in full on one line. */
.contact-phone {
  flex: 0 0 auto;
  white-space: nowrap;
}
/* Copy icons stay out of the way until you hover the row, keeping the default view clean. */
.contact-copy {
  color: #b6c0c9;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 11px;
  opacity: 0;
  transition: opacity 0.12s ease-in-out;
}
::v-deep tr:hover .contact-copy {
  opacity: 1;
}
.contact-copy:hover {
  color: #49d9bd;
}
/* Location column: City (primary) → State (muted) → flag + ISO (country). */
.location-cell {
  line-height: 1.3;
}
.loc-city {
  font-weight: 600;
  font-size: 12.5px;
}
.loc-state {
  font-size: 11px;
  color: #6b7782;
}
.loc-country {
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  margin-top: 2px;
  font-size: 12px;
}
.loc-country .flag-icon {
  flex-shrink: 0;
}
.loc-iso {
  font-weight: 600;
  color: #56606a;
}
.id-verification-container {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.id-verification-icon {
  font-size: 24px;
}

.id-verification-badge {
  font-size: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  border-radius: 50%;
  padding: 1px;
}
</style>